export default __webpack_public_path__ + "static/media/Rhombus.e2b1d826.svg";